export const VIEWPORT_TABLET = 768;
